<div class="container flex-col gap-16">
    <div [formGroup]="form"
         class="flex-col gap-16 form">
        <div class="flex-col gap-8">
            <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
            <input class="ui-input ui-input-40"
                   formControlName="name">
        </div>


        <div class="flex-col gap-8">
            <label>{{ 'FLOW_CHART.NODES.HTTPREQ.NAME'|translate }} <span class="required">*</span></label>

            <div class="flex-row gap-8 start-center">
                <ui-v2-selector [options]="selectHttpRequestsSig()"
                                [multi]="false"
                                class="selector"
                                searchProperty="name"
                                valueProperty="_id"
                                [placeholder]="!selectIsInitialLoadedSig() ? ('FLOW_CHART.LOADING_HTTPREQS'|translate) : ('FLOW_CHART.NODES.HTTPREQ.PLACEHOLDERS.SELECT'|translate)"
                                formControlName="httpRequestId"
                                [createBtnText]="'FLOW_CHART.NODES.HTTPREQ.CREATE_BTN'"
                                [manageBtnText]="'FLOW_CHART.NODES.HTTPREQ.MANAGE_BTN'"
                                (onCreateBtnClick)="create()"
                                (onManageBtnBtnClick)="manage()"
                                [required]="true"
                                [hasHeightClass]="true">
                </ui-v2-selector>

                @if(!disableForm() && selectNodeSig()) {
                <span class="ui-icon-edit c-p"
                      [matTooltip]="'COMMON.EDIT' | translate"
                      matTooltipClass="sidebar-tooltip"
                      (click)="edit()">
                </span>
                }
            </div>
        </div>
    </div>

    @if(selectNodeSig()) {
    <div class="copy-container">
        <div class="flex-col gap-8">
            <label>{{ 'FLOW_CHART.NODES.HTTPREQ.URL_LABEL'|translate }}</label>
            <div class="flex-row start-center gap-8">
                <input disabled
                       class="ui-input ui-input-40 w-100 org-id-input"
                       [value]="httpRequest?.address">
                <ui-copy-clipboard class="c-p"
                                   #clipboard
                                   [copyContent]="httpRequest?.address"
                                   (click)="clipboard.copyContent">
                </ui-copy-clipboard>
            </div>
        </div>
    </div>
    }
</div>